import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { shellRoute } from './index'

export const dashboardRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: '/dashboard',
  component: lazyRouteComponent(() => import('@/pages/dashboard'), 'DashboardPage'),
})
